import { IContact, IFile, IInfoBlockItem, IInfoBlockItemType, IPlace } from "shared/types";

export const getInfoBlockItemName = (item: IInfoBlockItemType, type: IInfoBlockItem): string => {
  switch (type) {
    default:
    case IInfoBlockItem.contact: {
      const contact = item as IContact;
      return `${contact.firstname} ${contact.lastname}`;
    }
    case IInfoBlockItem.place: {
      const place = item as IPlace;
      return place.title;
    }
    case IInfoBlockItem.file: {
      const file = item as IFile;
      return file.title || "";
    }
    case IInfoBlockItem.image: {
      return "";
    }
  }
};
